import {useAppDispatch, useAppSelector} from "../../common/store";
import {selectDrawModeState, updateDrawMode} from "./apDrawPoygonSlice";
import React, {useEffect} from "react";
import {Icon, IconGroup} from "semantic-ui-react";

export const APDrawPolygonButton = () => {

  const dispatch = useAppDispatch()
  const drawMode = useAppSelector(selectDrawModeState)

  useEffect(() => {
    dispatch(updateDrawMode({active: drawMode}))
  }, []);

  const handleClick = () => {
    dispatch(updateDrawMode({active: !drawMode}))
  }

  const getDrawMode = () => {
    return drawMode
  }

  return (
      <div className={'apDrawModeButton'}>
        <IconGroup>
          <Icon link name={'pencil'}
                color={getDrawMode() ? 'blue' : 'grey'}
                size={'huge'}
                onClick={handleClick} />

        </IconGroup>
      </div>
  )

}